export default __webpack_public_path__ + "static/media/teacher.04f7317f.svg";